<script lang="ts" setup generic="T">
  import type { BaseAccordionRow } from '@/shared/types/components.types'
  import { TOGGLE_EVENT_NAME, TEST_ID } from './BaseAccordion.constants'
  import BaseFoldingBlock from '@/shared/components/BaseFoldingBlock/BaseFoldingBlock.vue'

  interface Props {
    title: string
    rows: BaseAccordionRow<T>[]
  }
  interface Emits {
    (e: typeof TOGGLE_EVENT_NAME, isOpen: boolean, rowId: string): void
  }

  withDefaults(defineProps<Props>(), {
    rows: () => [],
  })

  const emit = defineEmits<Emits>()

  const onToggle = (isOpen: boolean, rowId: string) => {
    emit(TOGGLE_EVENT_NAME, isOpen, rowId)
  }
</script>

<template>
  <div class="base-accordion" :data-test="TEST_ID">
    <div class="base-accordion__header">
      <slot name="before-title" />
      <div class="base-accordion__title">
        <slot name="title">{{ title }}</slot>
      </div>
      <slot name="after-title" />
    </div>
    <div class="base-accordion__content">
      <BaseFoldingBlock
        v-for="row in rows"
        :key="row.id"
        class="base-accordion__row"
        :title="row.title"
        :is-open="row.isOpen"
        :can-fold="!!row.content"
        @toggle="onToggle($event, row.id)"
      >
        <slot name="content" v-bind="row">
          {{ row.content }}
        </slot>

        <template #after>
          <slot name="after-content" v-bind="row" />
        </template>
      </BaseFoldingBlock>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './BaseAccordion';
</style>
